import React, {useEffect, useState} from "react";
import rowSelectIcon from "../../img/rowDownIcon.svg";
import showPassIcon from "../../img/showPassIcon.svg";
import hidePassIcon from "../../img/hidePassIcon.svg";
import activeCheckIcon from "../../img/authActiveCheck.svg";
import emptyCheckIcon from "../../img/authEmptyCheck.svg";
import { Link } from "react-router-dom";
import { Validation } from "../../utils/Validation/Validation";

const Auth = (props) => {

    const {
        authError,
        setAuthError,
        handleLogin
    } = props

    const [activeShowPass, setActiveShowPass] = useState(true);
    const [activeRememberCheck, setActiveRememberCheck] = useState(true);
    const login = Validation();
    const pass = Validation();

    function onLoginButton() {
        if (login.value === '' || pass.value === '') {
           setAuthError('Necessary to fill in all the fields!')
        } else {
            setAuthError('');
            handleLogin(login.value, pass.value)
        }
    }

    useEffect(() => {
        const onKeyDown = e => {
            if(e.keyCode === 13) {
                onLoginButton();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [login, pass]);

    return (
        <div className="auth-wrapper">
            <div className="auth-container">
                <div className="auth-main-block">
                    <div className="auth-title-block">
                        <h1 className="auth-title-block__title">Enter</h1>
                    </div>
                    <div className="auth-email-block">
                        <label className="auth-email-block__email-label">Login</label>
                        <input className="auth-email-block__email-input"
                               placeholder={'Введите email'}
                               type={"email"}
                               value={login.value}
                               onChange={login.onChange}
                               required={true}
                        />
                        {/*<p className="auth-main-block__valid-text">{authError}</p>*/}
                        {/*<img src={rowSelectIcon} className="auth-email-block__row-icon" alt={'иконка-стрелочка'}/>*/}
                    </div>
                    <div className="auth-pass-block">
                        <label className="auth-pass-block__pass-label">Password</label>
                        <input type={activeShowPass ? "password" : "text"}
                               className="auth-pass-block__pass-input"
                               placeholder={'Введите пароль'}
                               value={pass.value}
                               onChange={pass.onChange}
                               required={true}
                        />
                        <img className="auth-pass-block__show-hide-pass"
                             onClick={() => setActiveShowPass(!activeShowPass)}
                             src={activeShowPass ? showPassIcon : hidePassIcon}
                             alt={'иконка пароль'}/>
                        <p className="auth-main-block__valid-text">{authError}</p>
                    </div>
                    <div className="auth-checkbox-block">
                        <div className="auth-checkbox-block__check-remember-me">
                            <img className="auth-checkbox-block__checkboxes"
                                 onClick={() => setActiveRememberCheck(!activeRememberCheck)}
                                 src={activeRememberCheck ? activeCheckIcon : emptyCheckIcon}
                                 alt={'иконка чекбокс'}/>
                            <p className="auth-checkbox-block__remember-me">Remember me</p>
                        </div>
                        <Link className="auth-checkbox-block__forget-pass" to={''}>Forgot password?</Link>
                    </div>
                    <Link className="auth-checkbox-block__link-reg" to={'/reg'}>Don't have an account yet? Register</Link>
                    <button onClick={onLoginButton} className="auth-button-enter">Sign in</button>
                </div>
            </div>
        </div>
    )
}
export default Auth;